exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-content-container[data-v-462ccd74]{height:250px!important;overflow-y:auto}.elementcontainer[data-v-462ccd74]{max-height:200px;overflow-y:auto}@media (max-width:768px){.modal-content-container[data-v-462ccd74]{height:calc(100vh - 250px)!important}.elementcontainer[data-v-462ccd74]{max-height:none;overflow-y:initial}}.card.border-blue[data-v-462ccd74]{border-color:#03a9f4!important}.card[data-v-462ccd74]:hover{box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24);cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-462ccd74","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/procedure/procedure-editor-elements/element-selector.vue
// module id = 1363
// module chunks = 0